[
  {
    "url": "https://app.salesloft.com/app/people/\\d+\\??.*",
    "urlForMock": "",
    "elements": [
      {
        "name": "Full Name",
        "selector": "#main-content div[class^='TitlePanel-styles__PersonInfoWrapper'] p"
      },
      {
        "name": "Contact Email",
        "selector": "#main-content div[class^='EmailAddressItem'] div"
      },
      {
        "name": "Company Name",
        "selector": "#main-content div[class^='TitlePanel-styles__PersonInfoWrapper'] a[href^='/app/company']"
      },
      {
        "name": "Company Website",
        "selector": "#main-content div[class^='TitlePanel-styles__ActionContainer'] > div:last-child a",
        "attributes": ["href"]
      }
    ]
  },
  {
    "url": "https://app.salesloft.com/app/company/\\d+\\??.*",
    "urlForMock": "",
    "elements": [
      {
        "name": "Company Name",
        "selector": "#main-content div[class^='AccTitlePanel'] p"
      },
      {
        "name": "Company Website",
        "selector": "#main-content div[class*='AccTitlePanel-styles__ActionContainer'] div:last-child a",
        "attributes": ["href"]
      }
    ]
  }
]
